
function GetSuggestedProducts() {
    if ($("#CurCatalogID").length > 0 && $(".AutoGetSuggested").length > 0) {
        $.ajax({
            type: "GET",
            url: getRequestRoute() + "/p/ProductDetails/GetSuggestedProducts" + getLandingParameter(),
            data: "ProductID=" + $("#ProductID").val() + "&CurCatalogID=" + $("#CurCatalogID").val() + "&ColorID=" + $(".Colors .ColorOptionItem.active:first a").attr("data-id"),
            cache: false,
            success: function (dt) {
                $(".AutoGetSuggested .AutoSetted").remove();

                if (dt != "") {
                    $(".AutoGetSuggested").append(dt);
                    //$(".AutoGetSuggested .Productsuggest .ProductList").addClass("col-xs-24");
                }
            }
        });
    }
}

function SetLastVisitedProductsStorage() {
    var LastVisitedPrds = [];
    var lastPrdsKey = "LastVisitedPrds-" + $("#SmallCountryCode").val() + "-" + $("#SmallLangCode").val();

    var LandingParam = getLandingParameter();

    if (LandingParam) {
        LandingParam = LandingParam.split('=')[1];

        lastPrdsKey += "-" + LandingParam;
    }

    if (typeof (Storage) !== "undefined") {
        if ($(".ProductHeader:first").length > 0 || $(".AutoGetLastVisited").length > 0) {
            var hours = 8; // Reset when storage is more than 24hours
            var now = new Date().getTime();
            var setupTime = localStorage.getItem('prdLastSetupTime');

            if (setupTime == null) {
                localStorage.setItem('prdLastSetupTime', now);
            } else {
                if (now - setupTime > hours * 60 * 60 * 1000) {
                    localStorage.removeItem(lastPrdsKey);
                    localStorage.setItem('prdLastSetupTime', now);
                }
            }

            var _productid = $("#ProductID:first").val();
            var _colorid = $("#ColorID:first").val();
            var _url = window.location.pathname;
            var _prdImg = $("#FirstAngle:first").val();//$("meta[property$=image]").attr("content");
            var _prdname = $(".ProductHeader:first").text();
            var _amount = $("#PriceVal").val();

            _prdname = _prdname.replace(/(\r\n|\n|\r)/gm, "").trim();

            LastVisitedPrds = GetLastVisitedData();

            var itemExist = false;

            for (var i = 0; i < LastVisitedPrds.length; i++) {
                if (LastVisitedPrds[i].ColorID == _colorid && LastVisitedPrds[i].ProductID == _productid) {
                    itemExist = true;
                }
            }

            if (!itemExist) {
                LastVisitedPrds.push({ Amount: _amount, ProductID: _productid, ColorID: _colorid, Url: _url, Img1: _prdImg, Img2: _prdImg, ProductName: _prdname });

                if (LastVisitedPrds.length > 6) {
                    LastVisitedPrds.shift();
                }

                localStorage.setItem(lastPrdsKey, JSON.stringify(LastVisitedPrds));
            }
        }
    }
}

function SlickSlider(SuggestedSlick) {
    var rtl = false;

    if ($("#SmallLangCode").val() == "ar") {
        rtl = true;
    }

    if (SuggestedSlick == "suggested") {
        $(".SuggestedProductsContainer.LastVisited .SuggestedProducts .ProductList").slick({
            nextArrow: "<div class='PrdImgRight right-arrow'><i class='sorsfont sorsfont-chevron-right'></i></div>",
            prevArrow: "<div class='PrdImgLeft left-arrow'><i class='sorsfont sorsfont-chevron-left'></i></div>",
            infinite: true,
            slidesToShow: 4,
            slidesToScroll: 1,
            lazyLoad: 'ondemand',
            arrows: true,
            rtl: rtl,
            responsive: [
                {
                    breakpoint: 991,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 1,
                        infinite: true,
                        dots: true
                    }
                }
            ]
        });
    }
    else if (SuggestedSlick == "main") {

        $('.ProductDetailsMainImage .row').on('init', function (event, slick, direction) {
            GenerateLocalLoading($('.ProductDetailImages'), "show");

            setTimeout(function () {
                $(".ProductDetailsMainImage").css("opacity", "1");

                GenerateLocalLoading($('.ProductDetailImages'), "hide");
            }, 1000);

        });

        $('.ProductDetailsMainImage .row').slick({
            infinite: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false,
            rtl: true,
            dots: true,
            lazyLoad: 'ondemand'
        });
    }
    else if (SuggestedSlick == "combine") {
        if ($(".SuggestedProductsContainer.CombineProduct .SuggestedProducts .ProductList .Prd").length > 3) {
            $(".SuggestedProductsContainer.CombineProduct .SuggestedProducts .ProductList").slick({
                nextArrow: "<div class='PrdImgRight right-arrow'><i class='sorsfont sorsfont-chevron-right'></i></div>",
                prevArrow: "<div class='PrdImgLeft left-arrow'><i class='sorsfont sorsfont-chevron-left'></i></div>",
                infinite: true,
                slidesToShow: 3,
                slidesToScroll: 1,
                //lazyLoad: 'ondemand',
                arrows: true,
                rtl: rtl,
                responsive: [
                    {
                        breakpoint: 991,
                        settings: {
                            slidesToShow: 2,
                            slidesToScroll: 1,
                            infinite: true,
                            dots: true
                        }
                    }
                ]
            });
        }
        //else if ($(".SuggestedProductsContainer.CombineProduct .SuggestedProducts .ProductList .Prd").length > 0) {
        //    $(".SuggestedProductsContainer.CombineProduct .SuggestedProducts .ProductList .Prd").each(function () {
        //        $(this).find(".PImage").attr("src", $(this).find(".PImage").attr("data-lazy"));
        //    });
        //}
    }
    else if (SuggestedSlick == "quickLook") {

        $('.ProductDetailImages .ProductDetailsMainImage ul').slick({
            nextArrow: "<div class='PrdImgRight right-arrow'><i class='sorsfont sorsfont-chevron-right'></i></div>",
            prevArrow: "<div class='PrdImgLeft left-arrow'><i class='sorsfont sorsfont-chevron-left'></i></div>",
            asNavFor: $('.QuickLookModal .SmallProductImages ul'),
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: true,
            rtl: rtl,
            dots: false,
            infinite: true,
            lazyLoad: 'ondemand'
        });

        $('.ProductDetailImages .SmallProductImages ul').slick({
            slidesToShow: 3,
            slidesToScroll: 1,
            asNavFor: '.ProductDetailImages .ProductDetailsMainImage ul',
            dots: false,
            arrows: false,
            rtl: rtl,
            centerMode: false,
            focusOnSelect: true,
            vertical: true,
            verticalSwiping: true
        });
    }
}

function SizeChart() {
    if ($(".SizeTable").length > 0) {
        $(document).on("click", ".ProductDetail .ProductOptions .Sizes .SizeChart a, .QuickLook .ProductOptions .Sizes .SizeChart a", function () {
            $(".SizeTable").addClass("open");
            $("body").addClass("no-scroll");
            $("body").addClass("rightMenu");
            $(".backdrop").addClass("rightMenu");
        });

        $(document).on("click", ".backdrop.rightMenu, .SizeTable .SizeTableClose", function () {
            $(".SizeTable").removeClass("open");

            setTimeout(function () {
                $("body").removeClass("no-scroll rightMenu");
                $(".backdrop").removeClass("rightMenu");
            }, 500);
        });
    }
}

$(document).ready(function () {
    IsfollowForProductDetails();
    GetSuggestedProducts();
    SizeChart();
    SlickSlider("main");

    //if (!isMobileResolution()) {
    //    $(".UseLazyLoadDetail").Lazy();
    //}
    //else {
    //    SlickSlider("main");
    //}

    if ($("body").hasClass("productdetails") && $("#CName").val() == "ProductDetails" && $("#AName").val() == "Index") {
        SetLastVisitedProductsStorage();
        var LastVisitedPrds = GetLastVisitedData();

        if (LastVisitedPrds != undefined && LastVisitedPrds.length > 0) {
            GetLastVisitedPrdView(LastVisitedPrds, function (dt) {
                if (dt != "") {
                    $(".SuggestedProductsContainer.LastVisited .AutoGetLastVisited").append(dt);

                    if ($(".productdetails .SuggestedProductsContainer .AutoGetLastVisited .SuggestedProducts").length > 0) {

                        if (!isMobileResolution()) {
                            SlickSlider("suggested");
                        }
                        else {
                            $(".UseLazyLoadSuggested").Lazy();
                        }
                    }
                }
            });
        }
    }

    //SEPETE EKLE
    $(document).on("click", ".ProductDetail .BasktButtons #Basket", function () {
        var SizeID = $("#SizeID").val();
        var ColorID = $("#ColorID").val();
        var ProductID = $("#PID").val();
        var Amount = 1;
        var LangID = $("#LangID").val();

        var BedenSec = $('#BedenSec').val();
        var RenkSec = $('#RenkSec').val();
        var UrunYok = $('#UrunYok').val();

        var basketButton = $(this);

        if (SizeID != undefined && ColorID != undefined && ProductID != undefined && SizeID != "" && ColorID != "" && ProductID != "") {
            var data = 'sizeID=' + SizeID + "&colorID=" + ColorID + "&productID=" + ProductID + "&adet=" + Amount + "&langID=" + LangID;

            AddToCard(data, function (dt) {
                if (dt.Sonuc == true) {
                    GetSepetIcerik(function (dt) {
                        $("#UserAndBasket").html(dt);

                        toggleBasket();
                    });
                }
                else {
                    SwalGenerate("error", dt.IslemSonucAciklama, getStandartMessages("Hata"), getStandartMessages("Kapat"));
                }
            });
        }
        else {
            if (ProductID == undefined || ProductID == "") {
                SwalGenerate("error", UrunYok, getStandartMessages("Hata"), getStandartMessages("Kapat"));
            }
            else if (SizeID == undefined || SizeID == "") {
                SwalGenerate("error", BedenSec, getStandartMessages("Hata"), getStandartMessages("Kapat"));
            }
            else if (ColorID == undefined || ColorID == "") {
                SwalGenerate("error", RenkSec, getStandartMessages("Hata"), getStandartMessages("Kapat"));
            }

        }

        return false;
    });

    //Ürün Beden Seçimi
    $(document).on("click", ".ProductDetail .SizeOptions a:not(.NotifyWhen)", function () {
        $(this).parents(".Sizes").find("#SizeID").val($(this).attr("data-id"));

        $(this).parents(".SizeOptions").find("a").removeClass("active");
        $(this).parents(".SizeOptions").find("span").removeClass("active");
        $(this).addClass("active");
        $(this).parent().addClass("active");
    });

    // Slider Setting
    $('.ProductDetailImages ul').on('afterChange', function (event, slick, currentSlide, nextSlide) {
        $(".SmallProductImages ul li").each(function () {
            if ($(this).data("slick-index") == currentSlide) {
                $("img", this).addClass("Selected");
            }
            else {
                $("img", this).removeClass("Selected");
            }
        });
    });

    // Open SizeTable Modal
    $(".SizeTableLink").live("click", function () {
        $("#SizeTable").modal();
    });

    if ($(".ProductDetail .Sizes .SizeOptions .ONE.SIZE").length > 0) {
        $(".ProductDetail .Sizes .SizeOptions .ONE.SIZE").trigger("click");
    }

    $(document).on("click", ".ProductDetail .AddToFavorite.passiveFavorite", function () {
        var ColorID = $("#ColorID").val();
        var ProductID = $("#ProductID").val();
        button = $(this);

        if (ProductID != undefined) {
            GenerateLocalLoading($("body"), "show");

            AddToFavorite(ColorID, ProductID, function (result, msg) {
                if (result == true) {
                    button.addClass("activeFavorite");
                    button.removeClass("passiveFavorite");
                    button.find(".sorsfont").removeClass("sorsfont-favorite").addClass("sorsfont-favorite-o");
                    SwalGenerate("success", "", getStandartMessages("IslemBasarili"), getStandartMessages("Kapat"));

                    setTimeout(function () {
                        if ($(".swal2-container .swal2-actions .swal2-confirm").length > 0) {
                            $(".swal2-container .swal2-actions .swal2-confirm").trigger("click");
                        }
                    }, 2000);
                }
                else {
                    SwalGenerate("warning", msg, getStandartMessages("IslemBasarisiz"), getStandartMessages("Kapat"));
                }

                GenerateLocalLoading($("body"), "hide");
            });
        }
    });

    $(document).on("click", ".ProductDetail .AddToFavorite.activeFavorite", function () {
        var ProductID = $("#ProductID").val();
        button = $(this);

        if (ProductID != undefined) {
            GenerateLocalLoading($("body"), "show");

            removeFavorite(ProductID, function (result) {
                if (result == true) {
                    button.addClass("passiveFavorite");
                    button.removeClass("activeFavorite");
                    button.find(".sorsfont").removeClass("sorsfont-favorite-o").addClass("sorsfont-favorite");

                    SwalGenerate("success", "", getStandartMessages("IslemBasarili"), getStandartMessages("Kapat"));

                    setTimeout(function () {
                        if ($(".swal2-container .swal2-actions .swal2-confirm").length > 0) {
                            $(".swal2-container .swal2-actions .swal2-confirm").trigger("click");
                        }
                    }, 2000);
                }
                else {
                    SwalGenerate("error", getStandartMessages("BirHataOlustu"), getStandartMessages("IslemBasarisiz"), getStandartMessages("TekrarDene"));
                }

                GenerateLocalLoading($("body"), "hide");
            });
        }
    });

});